import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImpersonationService {
  private impersonationToken: string | null = null;

  constructor() {
    const queryParams = this.parseQueryParams();
    this.impersonationToken = queryParams.get('userToken');
  }

  hasImpersonationToken(): boolean {
    return this.getImpersonationToken() !== null;
  }

  getImpersonationToken(): string | null {
    return this.impersonationToken;
  }

  private parseQueryParams(): URLSearchParams {
    return new URLSearchParams(window.location.search);
  }
}
